import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import { useSnackbar } from 'notistack';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'black',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogoShowVenda = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [titulo, setTitulo] = useState('');
  const [conteudo, setConteudo] = useState('');
  const { enqueueSnackbar } = useSnackbar();
  const conteudoRef = useRef(null);

  function handleClose() {
    setOpen(false);
  }

  useImperativeHandle(ref, () => ({
    handleOpen(titulo, conteudo) {
      setOpen(true);
      setTitulo(titulo);
      setConteudo(conteudo);
    },
  }));

  async function copiar() {
    if (navigator.clipboard) {
      const texto = conteudoRef.current?.innerText;
      await navigator.clipboard.writeText(texto);
      handleClose();
      enqueueSnackbar('Código copiado para a área de transferência!', {
        variant: 'success',
      });
    } else {
      handleClose();
      enqueueSnackbar('Não tem acesso a api de copia e cola!', {
        variant: 'error',
      });
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      disableBackdropClick
      disableEscapeKeyDown
      fullScreen
    >
      <DialogTitle id="form-dialog-title" onClose={handleClose}>
        {titulo}
      </DialogTitle>
      <DialogContent dividers>
        <Tooltip title="Copiar" placement="bottom" aria-label="add2">
          <IconButton aria-label="check" size="small" onClick={() => copiar()}>
            <FilterNoneIcon />
          </IconButton>
        </Tooltip>
        <div dangerouslySetInnerHTML={{ __html: conteudo }} ref={conteudoRef} />
      </DialogContent>
    </Dialog>
  );
});

export default DialogoShowVenda;
